export default __webpack_public_path__ + "static/media/CL02.c3a7e5b6.mp3";